import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/Z1.css";

// ⭐ Example 5 rows data – replace with your images, headings & text
import img1 from "../assets/images/item8/subitm1.jpg";
import img2 from "../assets/images/item8/subitm2.jpg";
import img3 from "../assets/images/item8/subitm3.jpg";
import img4 from "../assets/images/item8/subitm4.jpg";
import img5 from "../assets/images/item8/subitm5.jpg";
import img6 from "../assets/images/item8/subitm6.jpg";
import img7 from "../assets/images/item8/subitm7.jpg";


const rowsData = [
  {
    id: 1,
    title: "Portable Piston Air Compressor",
    text: "Compact piston air compressor for easy and reliable portable air supply.",
    img: img1,
    gradient: "gradient1",
    stars: 4,
    description: `Portable piston air compressors provide powerful compressed air in a compact design. Ideal for workshops, construction sites, and on-the-go applications. Built with durable components to handle heavy-duty tasks.`
  },
  {
    id: 2,
    title: "Industrial Stationary Air Compressor",
    text: "Heavy-duty stationary air compressor for continuous industrial operations.",
    img: img2,
    gradient: "gradient2",
    stars: 5,
    description: `Industrial stationary air compressors deliver high-capacity compressed air for factories. Designed for 24/7 operation in manufacturing and production plants. Built with robust motors for consistent performance and efficiency.`
  },
  {
    id: 3,
    title: "Diesel Trailer Mounted Air Compressor",
    text: "Mobile diesel-powered air compressor for remote and heavy-duty applications.",
    img: img3,
    gradient: "gradient3",
    stars: 3,
    description: `Diesel trailer-mounted air compressors provide portable high-pressure air supply. Perfect for construction sites, mining, and outdoor projects. Runs on diesel fuel for reliable operation in remote areas.`
  },
  {
    id: 4,
    title: "Vacuum Pump",
    text: "Efficient vacuum pump for industrial and laboratory applications.",
    img: img4,
    gradient: "gradient4",
    stars: 4,
    description: `Vacuum pumps create a controlled vacuum for industrial processes. Used in manufacturing, packaging, and scientific research. Available in rotary vane, liquid ring, and dry pump designs.`
  },
  {
    id: 5,
    title: "Electrical Control System",
    text: "Advanced electrical control systems for managing industrial operations.",
    img: img5,
    gradient: "gradient5",
    stars: 5,
    description: `Electrical control systems automate and regulate industrial machinery. Provide precise monitoring and control of electrical equipment. Improve safety, efficiency, and energy management.`
  },
  {
    id: 6,
    title: "Industrial Electrical Switcher",
    text: "Durable electrical switcher for safe and reliable power control.",
    img: img6,
    gradient: "gradient4",
    stars: 4,
    description: `Industrial electrical switchers manage the flow of electricity in large setups. Built to handle high voltage and heavy-duty operations. Ensure safe switching and protection of electrical equipment.`
  },
  {
    id: 7,
    title: "Portable Air Compressor",
    text: "Lightweight portable air compressor for quick and convenient air supply.",
    img: img7,
    gradient: "gradient5",
    stars: 4,
    description: `FiPortable air compressors offer easy mobility for on-site air needs. Ideal for home workshops, garages, and outdoor tasks. Compact and easy to carry with efficient air output.`
  }
];

function Z8() {
  const [selectedRow, setSelectedRow] = useState(null);

  return (
    <>
      <Navbar />

      <section className="z1-section">
        {rowsData.map((row) => (
          <div
            key={row.id}
            className={`z1-row ${row.gradient}`}
            onClick={() => setSelectedRow(row)}
          >
            <div className="z1-img">
              <img src={row.img} alt={row.title} />
            </div>

            <div className="z1-content">
              <h2>{row.title}</h2>
              <p>{row.text}</p>
              <div className="stars">
                {"★".repeat(row.stars)}
                {"☆".repeat(5 - row.stars)}
              </div>
            </div>
          </div>
        ))}
      </section>

      {/* 🔹 Popup / Modal */}
      {selectedRow && (
        <div className="z1-modal-overlay" onClick={() => setSelectedRow(null)}>
          <div
            className="z1-modal"
            onClick={(e) => e.stopPropagation()} // prevent close on inner click
          >
            <h2>{selectedRow.title}</h2>

            <div className="modal-body">
              <div className="modal-img">
                <img src={selectedRow.img} alt={selectedRow.title} />
              </div>
              <div className="modal-text">
                <p>{selectedRow.description}</p>
              </div>
            </div>

            <button
              className="close-btn"
              onClick={() => setSelectedRow(null)}
            >
              Close
            </button>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
}

export default Z8;